import React from 'react';

import { Flex, Tag, Tooltip } from 'antd-v5';
import cn from 'classnames';
import { MdHelp } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

import type { MeritBadgeUserRequirements } from '@appTypes/esb';
import { ConditionalRender } from '@shared/components';

import styles from './MeritBadgeInfoTag.scss';

export default function MeritBadgeInfoTag(props: {
  requirements?: MeritBadgeUserRequirements;
}) {
  const requirements = props.requirements;
  const isStarted = requirements?.versionId && requirements?.status;

  if (!requirements || !isStarted) {
    return (
      <Tag className={cn(styles.mbInfoTag)} bordered={false}>
        <Text
          font="body-caption"
          strong
          className={styles.adventureVersionTagTooltip}
        >
          <FormattedMessage
            id="bulkEntry.profileRow.versionTooltip.notStarted"
            defaultMessage="Not Started"
          />
        </Text>
      </Tag>
    );
  }

  return (
    <Tooltip
      placement="right"
      title={
        <Text
          font="body-caption"
          color="color-white"
          className={styles.adventureVersionTagTooltip}
        >
          <div>
            <FormattedMessage id="bulkEntry.profileRow.versionTooltip.status" />{' '}
            {requirements.status}
          </div>
          <div>
            <FormattedMessage id="bulkEntry.profileRow.versionTooltip.version" />{' '}
            {`${requirements.version}`}
          </div>

          <ConditionalRender value={!!requirements.dateEarned}>
            <div>
              <FormattedMessage id="bulkEntry.profileRow.versionTooltip.dateEarned" />{' '}
              {requirements.dateEarned}
            </div>
          </ConditionalRender>

          <ConditionalRender value={!!requirements.leaderApprovedDate}>
            <div>
              <FormattedMessage id="bulkEntry.profileRow.versionTooltip.leaderApprovedDate" />{' '}
              {requirements.leaderApprovedDate}
            </div>
          </ConditionalRender>
        </Text>
      }
    >
      <Tag className={cn(styles.mbInfoTag)} bordered={false}>
        <Flex align="center" gap={2}>
          <Text font="body-caption" strong>
            v{requirements.version}
          </Text>
          <MdHelp color={cssVars['color-info']} className={styles.tagIcon} />
        </Flex>
      </Tag>
    </Tooltip>
  );
}
